import styled from 'styled-components';

import { colors, zIndex } from '../../ui/variables';

export const RangeNavigationStyle = styled.div`
  width: 100%;
  
  &.blue-theme {
    width: 90%;
    -webkit-appearance: none;
    .input-range-element {
      &::-webkit-slider-runnable-track {
        background-color: #d7dbdd;
        height: 6px;
        border-radius: 3px;
        border: 1px solid transparent;
      }

      &[disabled]::-webkit-slider-runnable-track {
        border: 1px solid #d7dbdd;
        background-color: transparent;
        opacity: 0.4;
      }

      &::-moz-range-track {
        background-color: #d7dbdd;
        height: 6px;
        border-radius: 3px;
        border: none;
      }

      &::-ms-track {
        color: transparent;
        border: none;
        background: none;
        height: 6px;
      }

      &::-ms-fill-lower {
        background-color: #d7dbdd;
        border-radius: 3px;
      }

      &::-ms-fill-upper {
        background-color: #d7dbdd;
        border-radius: 3px;
      }

      &::-ms-tooltip {
        display: none;
      }

      &::-moz-range-thumb {
        border-radius: 20px;
        height: 18px;
        width: 18px;
        border: none;
        background: none;
        background-color: ${colors.softBlue};
      }

      &:active::-moz-range-thumb {
        outline: none;
      }

      &::-webkit-slider-thumb {
        -webkit-appearance: none !important;
        border-radius: 100%;
        background-color: ${colors.softBlue};
        height: 18px;
        width: 18px;
        margin-top: -7px;
      }

      &[disabled]::-webkit-slider-thumb {
        background-color: transparent;
        border: 1px solid #d7dbdd;
      }

      &:active::-webkit-slider-thumb {
        outline: none;
      }

      &::-ms-thumb {
        border-radius: 100%;
        background-color: ${colors.softBlue};
        height: 18px;
        width: 18px;
        border: none;
      }

      &:active::-ms-thumb {
        border: none;
      }
    }
  }




  &.light-theme {
    .input-range-element {
      &::-webkit-slider-thumb {
        background-color: ${colors.mostlyWhite};
      }

      &::-moz-range-thumb {
        background-color: ${colors.mostlyWhite};
      }

      &:before {
        background-color: ${colors.veryDarkGrayishBlue};
      }
    }
  }

  &.another-theme {
    &::-moz-range-thumb {
      border-radius: 20px;
      height: 18px;
      width: 18px;
      border: none;
      background: none;
      background-color: ${colors.softBlue};
    }

    &:active::-moz-range-thumb {
      outline: none;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none !important;
      border-radius: 100%;
      background-color: ${colors.softBlue};
      height: 18px;
      width: 18px;
      margin-top: -7px;
    }

    &[disabled]::-webkit-slider-thumb {
      background-color: transparent;
      border: 1px solid #d7dbdd;
    }

    &:active::-webkit-slider-thumb {
      outline: none;
    }

    &::-ms-thumb {
      border-radius: 100%;
      background-color: ${colors.softBlue};
      height: 18px;
      width: 18px;
      border: none;
    }

    &:active::-ms-thumb {
      border: none;
    }
  }

  &.dark-theme,
  &.default-theme {
    .input-range-element {
      &::-webkit-slider-thumb {
        background-color: ${colors.veryDarkGrayishBlue};
      }

      &::-moz-range-thumb {
        background-color: ${colors.veryDarkGrayishBlue};
      }

      &:before {
        background-color: ${colors.mostlyWhite};
      }
    }
  }

  .input-range-element {
    appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
    display: block;
    height: 16px;
    outline: none;
    position: relative;
    width: 100%;

    &::-webkit-slider-thumb {
      ${zIndex.hills};
      appearance: none;
      -webkit-appearance: none;
      border-radius: 50%;
      cursor: pointer;
      height: 16px;
      position: relative;
      width: 16px;
    }

    &::-moz-range-thumb {
      ${zIndex.hills};
      border-radius: 50%;
      cursor: pointer;
      height: 16px;
      position: relative;
      width: 16px;
    }

    &:before {
      content: '';
      display: block;
      height: 4px;
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
    }
  }
`;
